export const aiI18n = {
  ai: {
    en: {
      AI: 'AI',
      AI_MATCH: 'AI Match',
      AI_MATCH_NOT_FOUND: 'AI match not found',
      AI_MATCH_REQUEST_BY_AT: 'AI match requested by {{name}} on {{date}}',
      AI_MATCHES: 'AI Matches',
      AI_MATCHING_DISCLAIMER:
        'Our AI-generated matches should be considered preliminary and require review by qualified personnel before use. Decisions are ultimately based on a thorough assessment of relevant factors.',
      COMPLETED: 'Completed',
      COMPLETED_NO_MATCHES_FOUND:
        'No matches were found for the specified query. The result may have failed to match correctly. Please try again to see if you get better results.',
      COPY_MATCH: 'Copy match',
      ERROR_FETCHING_AI_MATCH: 'Error fetching AI match',
      FAILED: 'Failed',
      FAMILY_DESCRIPTION: 'Family description',
      GENERATE_MATCHES: 'Generate matches',
      GO_TO_FAMILY: 'Go to family',
      IN_PROGRESS: 'In progress',
      INITIATED_BY: 'Initiated by {{name}}',
      INITIATED_BY_AT: 'Initiated by {{name}} {{date}}',
      MATCH_COPIED: 'Match copied',
      MATCH_FAILED_TEXT: 'Matching failed. We apologize for any inconvenience.',
      MATCH_IN_PROGRESS_TEXT:
        'Matching process is currently in progress; our systems are carefully analyzing all available foster families to ensure the optimal match against the specified query. We appreciate your patience as this may take a while. You can leave the page and return later, as the matching is done in the background.',
      MATCHES: 'Matches',
      MATCHING_REASON: 'Matching reason',
      NEW_MATCH: 'New match',
      NO_MATCHES_FOUND: 'There are no matches to display.',
      PENDING: 'Pending',
      QUERY: 'Query',
      RERUNNING: 'Rerunning',
      RETRY: 'Retry',
      RISK_ASSESSMENT: 'Risk assessment',
      X_RUNS: '{{count}} runs',
    },
    'sv-SE': {
      AI: 'AI',
      AI_MATCH: 'AI-matchning',
      AI_MATCH_NOT_FOUND: 'AI-matchning hittades inte',
      AI_MATCH_REQUEST_BY_AT: 'AI-matchning begärd av {{name}} den {{date}}',
      AI_MATCHES: 'AI-matchningar',
      AI_MATCHING_DISCLAIMER:
        'Våra AI-genererade matchningar bör ses som preliminära och behöver granskas av behörig personal före användning. Beslut baseras slutligen på en noggrann bedömning av relevanta faktorer.',
      COMPLETED: 'Färdigsställd',
      COMPLETED_NO_MATCHES_FOUND:
        'Inga matchningar hittades för den angivna förfrågan. Det kan hända att resultatet inte lyckades matcha korrekt. Vänligen försök igen för att se om ni får bättre resultat.',
      COPY_MATCH: 'Kopiera matchning',
      ERROR_FETCHING_AI_MATCH: 'Fel vid hämtning av AI-matchning',
      FAILED: 'Misslyckad',
      FAMILY_DESCRIPTION: 'Familjebeskrivning',
      GENERATE_MATCHES: 'Generera matchningar',
      GO_TO_FAMILY: 'Gå till familj',
      IN_PROGRESS: 'Pågående',
      INITIATED_BY: 'Initierad av {{name}}',
      INITIATED_BY_AT: 'Initierad av {{name}} {{date}}',
      MATCH_COPIED: 'Matchning kopierad',
      MATCH_FAILED_TEXT:
        'Matchningen misslyckades. Vi ber om ursäkt för eventuella olägenheter.',
      MATCH_IN_PROGRESS_TEXT:
        'Matchningsprocessen pågår för närvarande; våra system analyserar alla tillgängliga familjehem noggrant för att säkerställa den optimala matchningen mot den angivna förfrågan. Vi ber om ert tålamod då detta kan ta en stund. Ni kan lämna sidan och återkomma senare, då matchningen sker i bakgrunden.',
      MATCHES: 'Matchningar',
      MATCHING_REASON: 'Matchningsanledning',
      NEW_MATCH: 'Ny matchning',
      NO_MATCHES_FOUND: 'Det finns inga matchningar att visa.',
      PENDING: 'Pågående',
      QUERY: 'Förfrågan',
      RERUNNING: 'Körs igen',
      RETRY: 'Försök igen',
      RISK_ASSESSMENT: 'Riskbedömning',
      X_RUNS: '{{count}} körningar',
    },
  },
};
